import React, { useState } from "react";
import PropTypes from "prop-types";
import FontAwesomeIcon from "../IME/Icon";
import { evaluate } from "../../../utilities/props";
import ToggleButton from "../../PlayerButtons/ToggleButton";

const Volume = ({ initial = 100, onChange = () => {} }) => {
  const [open, setOpen] = useState(false);
  const [level, setLevel] = useState(evaluate(initial));
  const [muted, setMuted] = useState(false);

  let value = muted ? 0 : level;
  return (
    <div
      className="Volume"
      onPointerEnter={() => setOpen(true)}
      onPointerLeave={() => setOpen(false)}
    >
      <div className="icon-flex">
        <ToggleButton
          className="volume-toggle"
          value={() => value}
          onChange={(active) => {
            const muted = !active;
            setMuted(muted);
            const value = muted ? 0 : level;
            onChange(value);
          }}
        >
          {(active) => {
            let icon = "volume-up";
            if (!active && value === 0) {
              icon = "volume-mute";
            } else if (value <= 30) {
              icon = "volume-off";
            } else if (value > 30 && value <= 60) {
              icon = "volume-down";
            }

            return (
              <FontAwesomeIcon
                fixedWidth
                icon={icon}
                className="mr-5 blue"
                size="lg"
              />
            );
          }}
        </ToggleButton>
        <input
          className="slider blue"
          type="range"
          step="1"
          min="0"
          max="100"
          value={value}
          onChange={(e) => {
            value = Number.parseInt(e.target.value, 10);
            setLevel(value);
            setMuted(false);
            onChange(value);
          }}
        />
      </div>
    </div>
  );
};

Volume.propTypes = {
  initial: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  onChange: PropTypes.func,
};

export default Volume;
